import React from 'react'

import { FilterOperator } from 'types/filter-page'

import { Flex, RadioGroup, Text } from 'components/ds'
import { formatComparisonOperator } from 'components/search/search-filters/utils'

// Generic over the radio key so forms can add UI-only options (e.g. the
// "No playlists" shortcut) whose value isn't a backend FilterOperator.
type OperatorOption<K extends string> = {
  label?: string
  value: K
  component: React.ReactNode
}

type Props<K extends string> = {
  operator: K
  operators: OperatorOption<K>[]
  onChange: (value: any, operator: K) => void
}

export const FilterOperatorSelector = <K extends string = FilterOperator>({
  operator,
  onChange,
  operators,
}: Props<K>) => {
  return (
    <RadioGroup.Root
      value={operator}
      onValueChange={newOperator => {
        onChange(undefined, newOperator as K)
      }}
    >
      <Flex gap="4" direction="column">
        {operators.map(option => (
          <RadioGroup.Item
            value={option.value}
            key={option.value}
            style={{
              width: '100%',
            }}
          >
            <Flex gap="2" direction="column">
              <Text>
                {option.label ?? formatComparisonOperator(option.value)}
              </Text>
              {option.value === operator && <span>{option.component}</span>}
            </Flex>
          </RadioGroup.Item>
        ))}
      </Flex>
    </RadioGroup.Root>
  )
}
